import React from 'react';
import PropTypes from 'prop-types';
import EmailTooltip from './EmailTooltip';

function EmailWithTooltip({ email, className }) {
  return (
    <EmailTooltip email={email}>
      <span className={className} data-test-id={`${email}-student-email`}>
        {email}
      </span>
    </EmailTooltip>
  );
}

EmailWithTooltip.propTypes = {
  email: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default EmailWithTooltip;
